export default __webpack_public_path__ + "static/easymoney-fallback-opengraph-image-a9418ab8b317dac4bf6b483a28b61439.png";